import React, { useEffect, useState } from 'react';
import MenuToggle from './MenuToggle';
import styles from './styles.module.css';
import DividerHorizontal from '@/components/general/DividerHorizontal';
import Api from '@/api';
import BlogsFiltersSection from '@/components/pages/blog/blogsContent/BlogsFiltersSection';
import { useLayoutContext } from '@/context/LayoutContext';
import { categoryType, setState } from '@/commonTypes';

export default function TopMenuSection({
  setPageNumber,
  categoryList,
  queryKey,
  page = '/products',
}: {
  setPageNumber: setState<string | number>;
  categoryList?: categoryType[];
  queryKey?: string;
  page?: string;
}) {
  const { activeCategories } = useLayoutContext();

  return (
    <div className={`${styles.topMenu}`}>
      <MenuToggle />
      <DividerHorizontal margin="8px" className={`${styles.seperator}`} />
      <BlogsFiltersSection
        category={categoryList}
        // totalCount={category?.response_details?.count}
        totalCount={21}
        activeCategory={activeCategories?.map((x) => x.slug)?.join(',')}
        setPageNumber={setPageNumber}
        urlQuery={true}
        activeKey="slug"
        page={page}
        className={`${styles.filterCategory}`}
        buttonClass={`${styles.buttonClass}`}
        removeAllQuearies={false}
        queryKey={queryKey}
      />
    </div>
  );
}
